import common from './common.json';
import auth from './auth.json';
import subscription from './subscription.json';
import tracks from './tracks.json';
import faqs from './faqs.json';
import legal from './legal.json';

export default {
  common,
  auth,
  subscription,
  tracks,
  faqs,
  legal,
};
